// learnMoreData.js
import masterBedroomImage from '../images/master_bedroom.jpeg';
import childrensBedroomImage from '../images/childrens_bedroom.jpeg';
import miniBedroomImage from '../images/mini_bedroom.jpeg';
import outsideKitchenImage from '../images/outside_kitchen.jpeg';
import livingRoomImage from '../images/living_room.jpeg';
import diningRoomImage from '../images/dining_room.jpeg';
import playAreaImage from '../images/play_area.jpeg';
import frontViewImage from '../images/frontview.jpg';

// Import videos
import frontOfHouseVideo from '../videos/front_of_house.mp4';
import frontYardTreeVideo from '../videos/front_yard_tree.mp4';
import insideLivingroomVideo from '../videos/inside_livingroom_1.mp4';
import livingroomVideo from '../videos/livingroom_1.mp4';
import outsideGateVideo from '../videos/outside_gate.mp4';
import outsideKitchen1Video from '../videos/outside_kitchen_1.mp4';
import outsideKitchen2Video from '../videos/outside_kitchen_2.mp4';

const learnMoreSections = [
    {
      key: 'property_overview',
      title: "Property Overview",
      description: "Welcome to our beautiful property featuring stunning views and modern amenities. Experience the perfect blend of comfort and luxury in a serene environment.",
      features: [
        { title: "Prime Location", desc: "Situated in a peaceful and accessible area" },
        { title: "Beautiful Grounds", desc: "Well-maintained gardens and outdoor spaces" },
        { title: "Modern Architecture", desc: "Contemporary design with traditional charm" },
      ],
      image: [
        { src: frontViewImage, alt: 'Front View of Property' },
      ],
      video: [
        { src: frontOfHouseVideo, alt: 'Front of House Tour' },
        { src: frontYardTreeVideo, alt: 'Front Yard and Tree Views' },
      ],
    },
    {
      key: 'master_bedroom',
      title: "Master Bedroom",
      description: "Experience luxury in our spacious master bedroom with premium amenities and elegant furnishings. Perfect for a relaxing and comfortable stay.",
      features: [
        { title: "Spacious Layout", desc: "Generous space with modern furniture" },
        { title: "Premium Amenities", desc: "High-quality bedding and furnishings" },
        { title: "Private Bathroom", desc: "En-suite bathroom with modern fixtures" },
      ],
      image: [
        { src: masterBedroomImage, alt: 'Master Bedroom' },
      ],
    },
    {
      key: 'childrens_bedroom',
      title: "Children's Bedroom",
      description: "A safe and fun environment designed specifically for children, featuring comfortable sleeping arrangements and dedicated play spaces.",
      features: [
        { title: "Child-Friendly", desc: "Safe and comfortable for all ages" },
        { title: "Play Area", desc: "Dedicated space for activities" },
        { title: "Storage Solutions", desc: "Ample space for toys and clothes" },
      ],
      image: [
        { src: childrensBedroomImage, alt: 'Childrens Bedroom' },
      ],
    },
    {
      key: 'mini_bedroom',
      title: "Mini Bedroom",
      description: "Our cozy mini bedroom offers comfort and functionality in a compact space, perfect for single travelers or as an additional sleeping area.",
      features: [
        { title: "Compact Design", desc: "Efficient use of space" },
        { title: "Essential Amenities", desc: "All necessary comforts included" },
        { title: "Modern Decor", desc: "Contemporary style and comfort" },
      ],
      image: [
        { src: miniBedroomImage, alt: 'Mini Bedroom' },
      ],
    },
    {
      key: 'outside_kitchen',
      title: "Outside Kitchen",
      description: "Enjoy cooking in our well-equipped outdoor kitchen with modern appliances and beautiful surroundings. Perfect for outdoor dining and entertainment.",
      features: [
        { title: "Modern Appliances", desc: "High-quality cooking equipment" },
        { title: "Dining Area", desc: "Comfortable outdoor seating" },
        { title: "Scenic Views", desc: "Beautiful surroundings while cooking" },
      ],
      image: [
        { src: outsideKitchenImage, alt: 'Outside Kitchen' },
      ],
      video: [
        { src: outsideKitchen1Video, alt: 'Outside Kitchen Tour 1' },
        { src: outsideKitchen2Video, alt: 'Outside Kitchen Tour 2' },
      ],
    },
    {
      key: 'living_room',
      title: "Living Room",
      description: "Relax and unwind in our comfortable living room featuring modern entertainment systems and cozy seating arrangements.",
      features: [
        { title: "Comfortable Seating", desc: "Soft sofas and armchairs" },
        { title: "Entertainment Center", desc: "Flat-screen TV and modern audio" },
        { title: "Cozy Ambiance", desc: "Warm lighting and comfortable atmosphere" },
      ],
      image: [
        { src: livingRoomImage, alt: 'Living Room' },
      ],
      video: [
        { src: livingroomVideo, alt: 'Living Room Tour' },
        { src: insideLivingroomVideo, alt: 'Inside Living Room Views' },
      ],
    },
    {
      key: 'dining_room',
      title: "Dining Room",
      description: "Enjoy meals in our elegant dining room with modern decor and comfortable seating, perfect for family gatherings and special occasions.",
      features: [
        { title: "Formal Dining", desc: "Formal dining setting for special occasions" },
        { title: "Modern Decor", desc: "Contemporary style and elegance" },
        { title: "Seating for 8", desc: "Suitable for family gatherings" },
      ],
      image: [
        { src: diningRoomImage, alt: 'Dining Room' },
      ],
    },
    {
      key: 'play_area',
      title: "Play Area",
      description: "Let your children play and have fun in our safe and well-equipped play area, designed to provide entertainment for kids of all ages.",
      features: [
        { title: "Safe Environment", desc: "Supervised play area with safety features" },
        { title: "Fun Activities", desc: "Games and toys for all ages" },
        { title: "Outdoor Space", desc: "Large outdoor area for play" },
      ],
      image: [
        { src: playAreaImage, alt: 'Play Area' },
      ],
    },
    {
      key: 'outdoor_spaces',
      title: "Outdoor Spaces",
      description: "Explore our beautiful outdoor areas including gardens, walkways, and scenic viewpoints that offer tranquility and natural beauty.",
      features: [
        { title: "Garden Areas", desc: "Beautifully landscaped gardens" },
        { title: "Walking Paths", desc: "Scenic walking routes around the property" },
        { title: "Viewing Points", desc: "Perfect spots for relaxation and photography" },
      ],
      video: [
        { src: outsideGateVideo, alt: 'Outside Gate and Entrance' },
      ],
    },
  ];
  
  export default learnMoreSections;
  